import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Grid, Typography, Paper } from '@material-ui/core';

const QACard = props => {
  const { card, classes } = props;
  const { question, answer } = card.fields;
  const qaCardImageSrc = get(card, [
    'fields',
    'image',
    'fields',
    'file',
    'url',
  ]);

  return (
    <Paper className={classes.QACard}>
      <Grid container>
        <Grid item xs={12}>
          <div>
            <Typography variant="h5" className={classes.valuePropHeading}>
              {question}
            </Typography>
            <div className={classes.answerText}>
              {documentToReactComponents(answer)}
            </div>
          </div>
        </Grid>
        {qaCardImageSrc && (
          <Grid item xs={8} className={classes.QAImage}>
            <img
              src={qaCardImageSrc}
              alt={question}
              className={classes.imageContainImg}
            />
          </Grid>
        )}
      </Grid>
    </Paper>
  );
};

const FAQSubheading = props => {
  const { subheading, classes } = props;
  const { title, qaCardCollection } = subheading.fields;

  return (
    <div className={classes.faqSubheadingContainer}>
      <Typography variant="h4" className={classes.faqSubheading}>
        {title}
      </Typography>
      {qaCardCollection &&
        qaCardCollection.map(qaCard => (
          <QACard card={qaCard} classes={classes} />
        ))}
    </div>
  );
};

QACard.propTypes = {
  card: PropTypes.any,
  classes: PropTypes.object,
};

FAQSubheading.propTypes = {
  subheading: PropTypes.any,
  classes: PropTypes.object,
};

export default FAQSubheading;
